import React, { useContext } from 'react';
import { useArrowNavigationGroup } from '@fluentui/react-components';

import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';

import { CopilotTab, CopilotTabItem } from '../CopilotTab';
import { CreativeFilters, CreativeFilterConfig } from './consts';
import { CreativeFilterType } from './types';

interface IFilterControlsProps {
  activeFilter: CreativeFilterType;
  onFilterChange: (filter: CreativeFilterType) => void;
}

export const FilterControl: React.FC<IFilterControlsProps> = ({ activeFilter, onFilterChange }) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const arrowNavigationsProps = useArrowNavigationGroup({ axis: 'both' });

  return (
    <div {...arrowNavigationsProps}>
      <CopilotTab active={activeFilter} onActiveChange={(newFilter) => onFilterChange(newFilter as CreativeFilterType)}>
        {
          CreativeFilters.map((filter) => (
            <CopilotTabItem key={filter} tabKey={filter}>
              {i18n.getString(CreativeFilterConfig[filter].label)}
            </CopilotTabItem>
          ))
        }
      </CopilotTab>
    </div>
  );
};
